import uuid from 'uuid';
import database from '../firebase/firebase';

// ADD_GAME
export const editWordOfDay = (wordOfDay) => {
    console.log("editWordOfDay = " + JSON.stringify(wordOfDay, null, 2));
    return ({
        type: 'EDIT_WORD_OF_DAY',
        wordOfDay
    });
};

export const startEditWordOfDay = (wordData) => {
    console.log("startEditWordOfDay = " + JSON.stringify(wordData, null, 2));

    return (dispatch, getState) => {
        return database.ref(`wordOfDay`).set(wordData.wordOfDay).then((ref) => {
            dispatch(editWordOfDay(wordData))
            console.log("updated wordOfDay");
        });
    };
};

export const setWordOfDay = (wordOfDay) => ({
    type: 'SET_WORD_OF_DAY',
    wordOfDay
});

export const startSetWordOfDay = () => {
    console.log("startSetWordOfDay called");
    return (dispatch, getState) => {
        const wordOfDayRef = database.ref(`wordOfDay`);
        wordOfDayRef.once('value', (snapshot) => {
            console.log("startSetWordOfDay once snapshot = " + JSON.stringify(snapshot, null, 2));
            dispatch(setWordOfDay(snapshot));
        });
        wordOfDayRef.on('value', (snapshot) => {
            console.log("startSetWordOfDay on snapshot = " + JSON.stringify(snapshot, null, 2));
            dispatch(setWordOfDay(snapshot));
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/wordOfDay.js